import { Navigate } from 'react-router';
import { useUserSelector } from '~/hooks/useUserSelector';
import { routes } from '~/routes';

// Catches legacy `/registration/*` deep links left over from the pre-redesign
// signup flow. The redesign no longer infers a step from filled-in data on
// refresh, so this just funnels everyone back to Step 1 (or login when no
// session exists).
export const RegistrationRedirect = () => {
  const user = useUserSelector();
  const target = user ? routes.signUpRedesign.yourInfo : routes.signUpRedesign.login;
  return <Navigate to={target} replace />;
};
